export const formatStringToSecret = (
    value?: string,
    cutLength: number = 3,
    secretLength: number = 12,
    replacer: string = '*'
): string => (value ? value.slice(0, cutLength).padEnd(secretLength, replacer) : '');
